import { Injectable } from '@angular/core';
import { HttpDataService } from './http-data.service';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WidgetService {

  private getURL = 'widget/apeiron-center/get/public/';
  private saveContactURL = 'contact/create';
  private saveCategoryURL = 'category-response/save';
  private getCategoryResultURL = 'category-response/result';
  private getAssessmentResultURL = 'category-response/full-assessment/result';
  private getIPLocationURL = 'https://api.db-ip.com/v2/free/self';


  constructor(public httpService: HttpDataService) { }


  get(id: string): Observable<any> {
    return this.httpService.getData(this.getURL + id).pipe(take(1));
  }

  saveContact(data: any): Observable<any> {
    return this.httpService.postData(this.saveContactURL, data).pipe(take(1));
  }

  saveCategoryData(data: any): Observable<any> {
    return this.httpService.postData(this.saveCategoryURL, data);
  }

  getCategoryResult(queryParams: any): Observable<any> {
    return this.httpService.getData(this.getCategoryResultURL, queryParams);
  }

  getAssessmentResult(queryParams: any): Observable<any> {
    return this.httpService.getData(this.getAssessmentResultURL, queryParams);
  }

}
